import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const InfoLineChart = ({ chartdata }) => {
  return (
    <ResponsiveContainer width={"95%"} height={400}>
      <AreaChart data={chartdata}>
        <defs>
          <linearGradient id='colorUv' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='5%' stopColor='#8884d8' stopOpacity={0.8} />
            <stop offset='95%' stopColor='#8884d8' stopOpacity={0} />
          </linearGradient>
          <linearGradient id='colorPv' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='5%' stopColor='#82ca9d' stopOpacity={0.8} />
            <stop offset='95%' stopColor='#82ca9d' stopOpacity={0} />
          </linearGradient>
        </defs>
        <XAxis stroke='#e4e9f2' dataKey='name' />
        <YAxis stroke='#e4e9f2' />
        <Legend
          verticalAlign='top'
          height={46}
          margin={{ top: 100, left: 0, right: 0, bottom: 0 }}
          iconType='square'
        />
        <Tooltip cursor={false} />
        <Area
          type='monotone'
          dataKey='uv'
          stroke='#8884d8'
          fillOpacity={1}
          fill='url(#colorUv)'
        />
        <Area
          type='monotone'
          dataKey='pv'
          stroke='#82ca9d'
          fillOpacity={1}
          fill='url(#colorPv)'
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default InfoLineChart;
